import { JsonApiResponse } from "./transformJsonApiResponse"

// Generic over the transformed shape so a caller that annotates its return type
// keeps it. The previous `Record<string, any>` erased it, which made annotating a
// transformer pointless.
export function createResponseTransformer<T>(
  transformJSON: (json: JsonApiResponse) => T | null
) {
  return (response: Response) => {
    const json = response?.json?.()
    if (json) {
      return json.then((result: JsonApiResponse | null | undefined) => {
        if (!result) {
          return null
        }
        return transformJSON(result)
      })
    }
    return null
  }
}
